import Image from 'next/image';

import Paragraph from '@/components/renderers/Paragraph';
import Authors from '@/components/Authors';
import CardLink from '@/components/CardLink';
import QuoteSVG from '@/svg/icons/quote.svg';

export default function Testimonial({
  externalUrl,
  linkPath,
  title,
  coverImage,
  customer,
  company,
}) {
  const hasLogo = company && company.logo;

  return (
    <CardLink externalUrl={externalUrl} linkPath={linkPath}>
      <div className="transform rounded shadow-lg transition-all duration-100 ease-in-out hover:scale-105 hover:shadow-2xl">
        <div className="relative">
          {coverImage && (
            <div className="z-20">
              <Image
                src={coverImage.url}
                title={title}
                alt={title}
                width={960}
                height={540}
                quality={100}
                objectFit="cover"
                className="rounded"
              />
            </div>
          )}
          <svg
            className="absolute bottom-0 left-0 -mb-1 w-full fill-current text-cornflower"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path d="M0,192L120,208C240,224,480,256,720,234.7C960,213,1200,139,1320,101.3L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z" />
          </svg>
        </div>

        <div className="rounded-b bg-cornflower p-6">
          {customer && (
            <div className="relative z-20 rounded bg-white p-6 text-haiti shadow-lg">
              {customer.bio && (
                <blockquote>
                  <div className="pin-t pin-l absolute -mt-3 -ml-3">
                    <QuoteSVG className="w-10 text-whisper" />
                  </div>

                  <div className="relative -mt-3">
                    <Paragraph className="text-sm italic">
                      {customer.bio}
                    </Paragraph>
                  </div>
                </blockquote>
              )}

              <div className="-ml-3 flex items-center justify-between">
                <div className="-ml-px flex-grow">
                  <Authors people={[customer]} showTitle />
                </div>

                {hasLogo && (
                  <div className="w-16">
                    <Image
                      src={company.logo.url}
                      width={company.logo.width}
                      height={company.logo.height}
                      title={company.name}
                      alt={company.name}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </CardLink>
  );
}
